import { Gender } from 'app/typings';

export const RULES = [{ required: true, message: 'This field is required' }];

export const formatGender = (gender: string | undefined) => {
  if (Object.values(Gender).includes(gender as Gender)) {
    return gender;
  }

  return gender === 'MALE' ? Gender.Mr : Gender.Mrs;
};
